
//  ActionLog.js
//  <project>
//  埋点操作信息
//  Created by licheng09 on 2017-10-17.
//  Copyright 2017 licheng09. All rights reserved.

import { is58App, isHaojieApp } from 'api/Helper';

const ua = navigator.userAgent.toLowerCase();
const ActionLog = {
    getIP() {
        // 获取IP ，后端获取

    },
    getLBS(success, error) {
        const _this = this;
        const result = {};

        // 获取LBS
        // APP自带定位
        if (is58App() || isHaojieApp()) {
            if (is58App()) {
                result.source = '58app';
            } else {
                result.source = 'haojieapp';
            }
            if (window.WBAPP.headers.lon) {
                _this.setWmdaReport({ event_id: '116', event_name: 'wbapp_authorization' });
                result.status = 0;
                result.lng = window.WBAPP.headers.lon;
                result.lat = window.WBAPP.headers.lat;
                result.isAuthorizedLocation = true;
                success && success(result);
            } else {
                geBDLocation('wbapp_on_authorization_h5_');
            }
        } else {
            result.source = 'h5';
            geBDLocation('h5_');
        }

        function getEventOptions(event_name) {
            let options = {};
            switch (event_name) {
                case 'h5_authorization':
                    options = { event_id: '115', event_name };
                    break;
                case 'h5_no_authorization':
                    options = { event_id: '95', event_name };
                    break;
                case 'wbapp_on_authorization_h5_authorization':
                    options = { event_id: '117', event_name };
                    break;
                case 'wbapp_on_authorization_h5_no_authorization':
                    options = { event_id: '118', event_name };
                    break;
                default:
                    break;
            }
            return options;
        }
        // 百度地图API功能
        function geBDLocation(mark) {
            if (window.BMap) {
                try {
                    _this.setWmdaReport(getEventOptions(`${mark}authorization`));
                    const geolocation = new window.BMap.Geolocation();
                    geolocation.getCurrentPosition(function (r) {
                        console.log(geolocation);
                        // 关于状态码
                        // BMAP_STATUS_SUCCESS    检索成功。对应数值“0”。
                        // BMAP_STATUS_CITY_LIST    城市列表。对应数值“1”。
                        // BMAP_STATUS_UNKNOWN_LOCATION    位置结果未知。对应数值“2”。
                        // BMAP_STATUS_UNKNOWN_ROUTE    导航结果未知。对应数值“3”。
                        // BMAP_STATUS_INVALID_KEY    非法密钥。对应数值“4”。
                        // BMAP_STATUS_INVALID_REQUEST    非法请求。对应数值“5”。
                        // BMAP_STATUS_PERMISSION_DENIED    没有权限。对应数值“6”。(自 1.1 新增)
                        // BMAP_STATUS_SERVICE_UNAVAILABLE    服务不可用。对应数值“7”。(自 1.1

                        if (this.getStatus() === 0) {
                            result.status = 0;
                            result.lng = r.point.lng;
                            result.lat = r.point.lat;
                            result.isAuthorizedLocation = true;
                            success && success(result);
                        } else {
                            result.status = this.getStatus();
                            result.isAuthorizedLocation = false;
                            error && error(result);
                        }
                    }, { enableHighAccuracy: true });
                } catch (e) {
                    _this.setWmdaReport(getEventOptions(`${mark}no_authorization`));
                    result.status = -1;
                    result.isAuthorizedLocation = false;
                    error && error(result);
                }
            } else {
                _this.setWmdaReport(getEventOptions(`${mark}no_authorization`));
                result.status = -1;
                result.isAuthorizedLocation = false;
                error && error({ status: -1 });
            }
        }
    },
    getIMEI() {
        // 获取IMEI，后端从cookie获取
    },
    getOS() {
        // 获取操作系统
        let os = null;
        if (/android|adr/.test(ua) && !(/windows phone/.test(ua))) {
            os = 'android';
        } else if (ua.indexOf('mac os') > -1 && ua.indexOf('mobile') > -1) {
            os = 'ios';
        } else {
            os = 'pc';
        }
        return os;
    },
    getUnitType() {
        // 获取设备型号
        return ua;
    },
    getOrigin() {
        // 获取页面来源
    },
    getNetwork() {
        // 获取网络类型,h5无法获取
    },
    getResolutionRatio() {
        // 获取屏幕分辨率
        return `${window.screen.width * window.devicePixelRatio}x${window.screen.height * window.devicePixelRatio}`;
    },
    setWmdaReport(obj = {}) {
        // WMDA 手动埋点
        const tempObj = {};
        tempObj.client = this.getOS();
        if (window.anjuke) {
            tempObj.from = 'anjukeApp';
        }
        Object.assign(obj, tempObj);
        if (window.WMDA_REPORT) {
            window.WMDA_REPORT('custom', obj);
        } else {
            console.log(obj);
        }
    },
    getBuriedPoints(callBack) {
        // 风控埋点
        let buriedInfo = {};

        if (isHaojieApp()) {
            window.WBAPP.invoke('get_app_device_info', { sync: true }, (result) => {
                buriedInfo = result || {};
                buriedInfo.platform = undefined;
                buriedInfo.resolution = undefined;
            });
            window.WBAPP.invoke('push_notification_data');
        }

        buriedInfo.os = this.getOS();
        buriedInfo.ua = this.getUnitType();

        this.getLBS((result) => {
            buriedInfo.lon = result.lng;
            buriedInfo.lat = result.lat;
            buriedInfo.source = result.source;
            buriedInfo.isAuthorizedLocation = result.isAuthorizedLocation;
            buriedInfo.resolutionRatio = this.getResolutionRatio();
            callBack && callBack(JSON.stringify(buriedInfo));
        }, (result) => {
            buriedInfo.source = result.source;
            buriedInfo.isAuthorizedLocation = result.isAuthorizedLocation;
            buriedInfo.resolutionRatio = this.getResolutionRatio();
            callBack && callBack(JSON.stringify(buriedInfo));
        });
    },
};
export default ActionLog;



// WEBPACK FOOTER //
// ./src/api/ActionLog.js